import { render, staticRenderFns } from "./Devolution.vue?vue&type=template&id=6a72e41e&scoped=true"
import script from "./Devolution.vue?vue&type=script&lang=js"
export * from "./Devolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a72e41e",
  null
  
)

export default component.exports